export default {
  how_to_place_order: {
    header: '¿Cómo hago un pedido?',
    body: 'Simplemente navega por el menú, añade artículos a tu carrito y sigue los pasos para finalizar. Recibirás una confirmación una vez realizado el pedido.',
  },
  schedule_order: {
    header: '¿Puedo programar un pedido con anticipación?',
    body: '¡Sí! Al finalizar el pedido, elige la opción «Programar» para establecer una hora de recogida futura que te convenga.',
  },
  customize_order: {
    header: '¿Puedo personalizar mi pedido?',
    body: 'Por supuesto. Toca un artículo del menú para ver las opciones de personalización, como ingredientes adicionales, acompañamientos y preferencias.',
  },
  track_order: {
    header: '¿Cómo hago seguimiento de mi pedido?',
    body: 'Tras realizar tu pedido, verás actualizaciones en tiempo real en la app, desde la confirmación hasta la preparación y la disponibilidad para recoger.',
  },
  cancel_or_edit_order: {
    header: '¿Puedo cancelar o editar mi pedido después de realizarlo?',
    body: 'Si tu pedido aún no ha comenzado a prepararse, puedes solicitar cambios llamando directamente al restaurante desde la app.',
  },
  payment_methods: {
    header: '¿Qué métodos de pago aceptan?',
    body: 'Aceptamos las principales tarjetas de crédito/débito, Apple Pay y Google Pay, según tu dispositivo.',
  },
  no_confirmation: {
    header: 'No recibí una confirmación. ¿Qué debo hacer?',
    body: 'Revisa la carpeta de spam de tu correo o visita la pestaña Pedidos en la app. Si aún no lo encuentras, contacta directamente al restaurante.',
  },
  pickup_instructions: {
    header: '¿Dónde recojo mi pedido?',
    body: 'Las instrucciones de recogida se muestran en la pantalla de confirmación y en el resumen de tu pedido. Busca señalización o pregunta al personal al llegar.',
  },
  loyalty_points: {
    header: '¿Puedo acumular puntos de fidelidad con mis pedidos?',
    body: 'Sí, las compras elegibles acumulan puntos automáticamente. Puedes ver tu saldo y recompensas en la pantalla principal de la app.',
  },
  apply_promo_code: {
    header: '¿Cómo aplico un código promocional o descuento?',
    body: 'Durante el proceso de pago, verás una opción para ingresar un código promocional. Los descuentos disponibles también se aplican automáticamente si eres elegible.',
  },
  issue_with_order: {
    header: '¿Qué hago si hay un problema con mi pedido?',
    body: 'Estamos aquí para ayudarte. Contacta al restaurante a través de la app o escribe al soporte directamente usando la opción Contactar con soporte.',
  },
  use_loyalty_and_coupon: {
    header: '¿Puedo usar puntos de fidelidad y un cupón (como 2×1) en el mismo pedido?',
    body: 'No: solo se puede aplicar un descuento u oferta por pedido. Esto garantiza un uso justo de las recompensas y promociones. ¡Elige la opción que te dé mayor beneficio!',
  },
};
